export const RecoilAtomKey = {
  supplierListKey: 'supplierListKey',
  userListkey: 'userListKey',
  interveneFilterKey: 'interveneFilterKey',
  userDetailKey: 'userDetailKey',
  userJourneyKey: 'userJourneyKey',
  callersListKey: 'callersListKey',
  dialerAgentListKey: 'dialerAgentListKey',
  stateListKey: 'stateListKey',
  userMinimalListKey: 'userMinimalListKey',
  organisationResponseKey: 'organisationResponseKey',
  organisationFilterKey: 'organisationFilterKey',
  organisationFormDataKey: 'organisationFormDataKey',
  organisationFormDataErrorKey: 'organisationFormDataErrorKey',
  organisationTableStateKey: 'organisationTableStateKey',
  fetchOrganisationsSelectorKey: 'fetchOrganisationsSelectorKey',

  addPocFormKey: 'addPocFormKey',
  messageListKey: 'messageListKey',
  showMobileViewKey: 'showMobileViewKey',
  campaignListKey: 'campaignListKey',
  fetchCampaignListSelectorKey: 'fetchCampaignListSelectorKey',
  userSupplierListKey: 'userSupplierListKey',
  campaignDropdownStateKey: 'campaignDropdownStateKey',
  // Lead Web Form
  dynamicLeadFormKey: 'dynamicLeadFormKey',
  leadDetailObjKey: 'leadDetailObjKey',
  leadAllCountsKey: 'leadAllCountsKey',
  leadB2b2cDetailObjkey: 'leadB2b2cDetailObjkey',
  isLeadFormValidateKey: 'isLeadFormValidateKey',
  B2b2cFormErrorKey: 'B2b2cFormErrorKey',
  referenceFieldKey: 'referenceFieldKey',
  formEnableDisableKey: 'formEnableDisableKey',
  phoneNumberForFormKey: 'phoneNumberForFormKey',
  leadListKey: 'leadListKey',
  channelListKey: 'channelListKey',
  channelInfoKey: 'channelInfoKey',
  userInfoByNumberKey: 'userInfoByNumberKey',
  leadFormQuickTemplateKey: 'leadFormQuickTemplateKey',
  userInfoFormEnableDisableKey: 'userInfoFormEnableDisableKey',
  knowlarityApiResponseKey: 'knowlarityApiResponseKey',
  userRawLeadFormDataKey: 'userRawLeadFormDataKey',
  phoneNumberAllLeadsKey: 'phoneNumberAllLeadsKey',

  // OPS VERIFY
  SectorListByNumberKey: 'SectorListByNumberKey',
  LeadsBySectorKey: 'LeadsBySectorKey',
  QuetionsBySectorKey: 'QuetionsBySectorKey',
  B2bFormDataKey: 'B2bFormDataKey',

  // WhatsAppTemplate
  WhatsAppTempFormKey: 'WhatsAppTempFormKey',
  callStatusListKey: 'callStatusListKey',
  TempFormErrorsKey: 'TempFormErrorsKey',
  TempFormButtonsKey: 'TempFormButtonsKey',
  templateTableStateKey: 'templateTableStateKey',
  fetchTemplateListSelectorKey: 'fetchTemplateListSelectorKey',
  templateSummaryTableStateKey: 'templateSummaryTableStateKey',
  fetchTemplateSummarySelectorKey: 'fetchTemplateSummarySelectorKey',

  // caller dashboard
  agentSummaryColumnKey: 'agentSummaryColumnKey',
  agentSelectedDispositionKey: 'agentSelectedDispositionKey',
  agentDatewiseSelectedDispositionKey: 'agentDatewiseSelectedDispositionKey',

  //Order list
  selectedOrderKey: 'selectedOrderKey',
  orderListObjKey: 'orderListObjKey',
  orderFiltersKey: 'orderFiltersKey',
  paymentStatusListKey: 'paymentStatusListKey',
  orderStatusKey: 'orderStatusKey',

  // product list
  productListObjKey: 'productListObjKey',
  productFiltersKey: 'productFiltersKey',
  selectedProductKey: 'selectedProductKey',

  // FlowBuilder
  flowObjKey: 'flowObjKey',
  flowValidationKey: 'flowValidationKey',
  botFlowDataKey: 'botFlowDataKey',
  flowsTableStateKey: 'flowsTableStateKey',
  fetchFlowListSelectorKey: 'fetchFlowListSelectorKey',
  entityPreviewKey: 'entityPreviewKey',
  entityDropdownAtomFamilyKey: 'entityDropdownAtomFamilyKey',

  // Management
  profileObjKey: 'profileObjKey',
  createUserFormDataKey: 'createUserFormDataKey',
  createUserFormDataErrorsKey: 'createUserFormDataErrorsKey',

  // Ecommerce
  setUpFlowDataKey: 'setUpFlowDataKey',
  setUpFlowNodeEdgeKey: 'setUpFlowNodeEdgeKey',

  //Entity
  entityTableStateKey: 'entityTableStateKey',
  entityDetailStateKey: 'entityDetailStateKey',
  fetchInvoiceProposalsSelectorKey: 'fetchInvoiceProposalsSelectorKey',

  // Leads
  leadsTableStateKey: 'leadsTableStateKey',
  fetchLeadDataSelectorKey: 'fetchLeadDataSelectorKey',
  campaignDataMapKey: 'campaignDataMapKey',
  fetchCampaignListSelectorKey: 'fetchCampaignListSelectorKey',
  fetchCampaignDropdownListSelectorKey: 'fetchCampaignDropdownListSelectorKey',
  campaignLeadManagementKey: 'campaignLeadManagementKey',
  assignedCampaignUserKey: 'assignedCampaignUserKey',
  dynamicWebFormPreviewDataKey: 'dynamicWebFormPreviewDataKey',

  // Report
  reportTemplateDetailsKey: 'reportTemplateDetailsKey',

  // AI
  aiStateKey: 'aiStateKey',
  projectAndQueryListKey: 'projectAndQueryListKey',

  // Vector Database
  multiKnowledgeBaseSearchKey: 'multiKnowledgeBaseSearchKey',
  singleKnowledgeBaseSearchKey: 'singleKnowledgeBaseSearchKey',
  getFileKey: 'getFileKey',
};
